// ======================================================================
// File Name       : BoxConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ModalIds from './ModalIds';

export const REDIRECT_MODAL = {
  [ModalIds.BOX_DETAIL]: {
    OK: ModalIds.BOX_REGISTER_EDIT,
  },

  [ModalIds.BOX_REGISTER_EDIT]: {
    OK: ModalIds.BOX_CONFIRM,
  },

  [ModalIds.BOX_CONFIRM]: {
    CANCEL: ModalIds.BOX_REGISTER_EDIT,
  },
};

export const CHOSEN_THUMBNAIL_BOX = {
  DEFAULT: 0,
  MANUAL: 1,
  NOTHING: -1,
};

export const END_CONDITION_TYPE_FOR_BOX = {
  NONE: 0,
  AND: 1,
  OR: 2,
  PROGRESS: 3,
  ALL_ITEM_COMPLETED: 4, // Step 10.2.0
};

export const END_CONDITION_TYPE_FOR_BOX_LIST = [0, 1, 2, 3]; // Step 10.2.0
